import React, { useState } from "react";
import { Popover, Tabs, Box, ActionIcon } from "@mantine/core";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";

import IconSelect from "../../sidebar/IconSelect";

import { displayEmoji } from "../../../../utils/Emoji";

export default function FilterIconSelector({ emojicon, onChangeEmojiicon }) {
  const [opened, setOpened] = useState(false);

  const onTabChange = (event) => {
    if (event === 3) {
      onUpdate(null);
    }
  };

  const onEmojiSelect = (emoji) => {
    onUpdate(`emoji/${emoji.id}`);
  };

  const onIconSelect = (icon) => {
    onUpdate(`icon/${icon}`);
  };

  const onUpdate = (value) => {
    if (typeof onChangeEmojiicon === "function") {
      onChangeEmojiicon(value);
    }
    setOpened(false);
  };

  return (
    <Popover
      opened={opened}
      onClose={() => setOpened(false)}
      target={
        <ActionIcon onClick={() => setOpened(true)}>
          {displayEmoji(emojicon, "grey")}
        </ActionIcon>
      }
      width={355}
      position="right"
      placement="start"
      zIndex={99999}
      spacing={0}
      withinPortal={false}
    >
      <Tabs
        styles={{
          tabActive: { fontWeight: "bold" },
          tabLabel: { color: "grey" },
        }}
        onTabChange={onTabChange}
      >
        <Tabs.Tab label="Emoji">
          <Picker
            data={data}
            onEmojiSelect={onEmojiSelect}
            navPosition={"bottom"}
            theme="light"
          />
        </Tabs.Tab>
        <Tabs.Tab label="Icons">
          <IconSelect onIconSelect={onIconSelect} />
        </Tabs.Tab>
        <Box style={{ flex: 1 }}></Box>
        <Tabs.Tab label="Remove"></Tabs.Tab>
      </Tabs>
    </Popover>
  );
}